import React from "react";
import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
const useClasses = makeStyles()((theme) => ({
  container: {
    padding: theme.spacing(2),
    margin: "auto",
    textAlign: "center",
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary
  },
  alignSpaceBetweenContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: `${theme.spacing(2)} 0`,
    textAlign: "unset",
    borderRadius: theme.spacing(1)
  }
}));
function InfoMessage({ children, dataTestId, align = "center" }) {
  const { classes, cx } = useClasses();
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(align === "space-between" ? classes.alignSpaceBetweenContainer : "", classes.container),
      "data-testid": dataTestId
    },
    children
  );
}
export {
  InfoMessage
};
//# sourceMappingURL=InfoMessage.js.map
